import { Routes } from '@angular/router';
import { ChangesNotSavedGuard } from '../../shared/components/changes-not-saved';
import { AuthGuard } from '../auth/guards';
import { ApplicationComponent } from './application.component';
import {
    ApplicationSubmittedComponent,
    BackgroundComponent,
    DisclosureComponent,
    PersonalInformationComponent,
    YourEducationComponent
} from './pages';
import { ApplicationConfirmationComponent } from './pages/application-confirmation/application-confirmation.component';

export const applicationRoutes: Routes = [
    {
        path: ':clientCode/application',
        component: ApplicationComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'personal-information',
                component: PersonalInformationComponent,
                canDeactivate: [ChangesNotSavedGuard]
            },
            {
                path: 'background',
                component: BackgroundComponent,
                canDeactivate: [ChangesNotSavedGuard]
            },
            {
                path: 'your-education',
                component: YourEducationComponent,
                canDeactivate: [ChangesNotSavedGuard]
            },
            {
                path: 'disclosure',
                component: DisclosureComponent,
                canDeactivate: [ChangesNotSavedGuard]
            },
            { path: '', redirectTo: 'personal-information', pathMatch: 'full' }
        ]
    },
    {
        path: ':clientCode/application-submitted',
        component: ApplicationSubmittedComponent,
        canActivate: [AuthGuard]
    },
    {
        path: ':clientCode/application-confirmed',
        component: ApplicationConfirmationComponent,
        canActivate: [AuthGuard]
    }
];
